module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic9.038b8d0a.png";